import { toBlob } from "html-to-image";

export const useCapture = () => {
  const handleCapture = async (
    element: HTMLElement | null,
    backgroundColor: string = "#0a092e",
  ) => {
    if (!element) return;
    try {
      const blob = await toBlob(element, {
        backgroundColor,
        cacheBust: true,
        filter: (node: any) => {
          if (node.tagName === "VIDEO") return false;
          return true;
        },
      });

      if (!blob) return;
      try {
        const item = new ClipboardItem({ "image/png": blob });
        await navigator.clipboard.write([item]);
      } catch (err) {
        console.error("클립보드 저장 실패:", err);
      }
    } catch (err) {
      console.error("캡처 실패:", err);
    }
  };

  return { handleCapture };
};
